import { environment } from '@/environments/environment';
import axios from 'axios';

export const axiosClient = axios.create({
  baseURL: environment.baseUrl + '/api'
});
